import Link from 'next/link';
import styles from './promotion-announcement-banner.module.scss';

const PromotionAnnouncementBanner = () => {
  return (
    <div className={styles.banner}>
      <div className={`container ${styles.inner}`}>
        <span className={styles.text}>
          Reserve your 2027 Jet Card with just one-third down — available
          through December 31
        </span>
        <Link href="/hera-jet-card-membership" className={styles.cta}>
          View Offer
          <svg
            className={styles.arrow}
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M2.917 7h8.166M7.583 4.083 10.5 7l-2.917 2.917"
              stroke="currentColor"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Link>
      </div>
    </div>
  );
};

export default PromotionAnnouncementBanner;
